<template>
	<div>
		<div class="features" style="height: 480px;">
			<div class="content modle-box" style="justify-content: space-between;">
				<div class="describe" style="margin-bottom: 20px;margin-top: 30px;">
					<div class="line-1">关于淘速取</div>
					<div class="line-2"></div>
				</div>
				<div style="width: 915px;color: #303030;font-size: 18px;color: #303030">
					<div>　　淘速取专注于校园免费代取快递服务，大学生可通过APP免费代取，同时淘速取APP内提供淘宝、天猫等大型电商平台多种产品，从源头完成大学生购买到取件的一站式服务。</div>
					<div>　　项目核心成员来自阿里、华为、腾讯等产品研发部门，算法团队由西安交通大学金融学院教授及其博士生团队领衔，此外淘速取还招纳了营销领域、互联网运营领域的高端人才，既可以为合作伙伴提供强力的技术、平台及运营支撑，又可以为员工提供良好的工作学习和个人成长环境。</div>
				</div>
				<img style="width: 400px;height: 200px;" src="../image/guanyu_shouji@2x.png" />
			</div>
		</div>

		<div class="introduce">
			<div class="content modle-box">
				<div class="describe">
					<div class="line-1">产品介绍</div>
					<div class="line-2"></div>
				</div>
				<div class="item-box">
					<div class="item">
						<div class="img-box">
							<img src="../image/guanyu_mianfei@2x.png" />
						</div>
						<div class="text-box">
							<div style="font-weight: bold;color: #333333;font-size: 22px;height: 120px;line-height: 120px;">免费代取快递</div>
							<div style="#333333;font-size: 18px;width: 445px;line-height: 36px;">
								在淘速取APP下单，即可获取代取码,查码可查看自己的代取码，包括未使用、已使用,并能查看获取时间以及使用时间,在代取页面中填写详细信息,提交订单就可以免费代取快递.
							</div>
						</div>
					</div>
					<div class="item">
						<div class="img-box">
							<img src="../image/guanyu_shouye@2x.png" />
						</div>
						<div class="text-box">
							<div style="font-weight: bold;color: #333333;font-size: 22px;height: 120px;line-height: 120px;">首页</div>
							<div style="#333333;font-size: 18px;width: 445px;line-height: 36px;">
								通过大数据算法筛选淘宝、天猫、京东、拼多多最优惠商品，根据用户购买习惯自动推荐，做到了千人千面精准导购，价格低、品质高。致力于成为广大学生省钱好帮手，网购少花钱！领券下单，省到没朋友！
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="features" style="height: 817px;">
			<div class="content modle-box">
				<div class="describe" style="margin-bottom: 80px;">
					<div class="line-1">代取订单</div>
					<div class="line-2"></div>
				</div>
				<div class="item-box">
					<img src="../image/guanyu_xiadan@2x.png" style="width: 274px;height: 488px;" />
					<img src="../image/guanyu_peisong@2x.png" style="width: 274px;height: 488px;" />
					<img src="../image/guanyu_songda@2x.png" style="width: 274px;height: 488px;" />
					<img src="../image/guanyu_quxiao@2x.png" style="width: 274px;height: 488px;" />
				</div>
			</div>
		</div>


		<div class="features" style="height: 554px;background-color: #f6f6f6;">
			<div class="content modle-box">
				<div class="describe" style="margin-bottom: 80px;">
					<div class="line-1">三大优势</div>
					<div class="line-2"></div>
				</div>
				<div class="item-box">
					<img src="../image/guanyu_yous1@2x.png" style="width: 365px;height: 277px;" />
					<img src="../image/guanyu_yous2@2x.png" style="width: 365px;height: 277px;" />
					<img src="../image/guanyu_yous3@2x.png" style="width: 365px;height: 277px;" />

				</div>
			</div>
		</div>


		<div class="features" style="height: 560px;">
			<div class="content modle-box">
				<div class="describe" style="margin-bottom: 80px;">
					<div class="line-1">专业团队 最新技术</div>
					<div class="line-2"></div>
				</div>
				<div class="item-box">
					<img src="../image/guanyu_huaxiang@2x.png" style="width: 269px;height: 269px;" />
					<img src="../image/guanyu_fensi@2x.png" style="width: 269px;height: 269px;" />
					<img src="../image/guanyu_fenlie@2x.png" style="width: 269px;height: 269px;" />
					<img src="../image/guanyu_zhuanhuan@2x.png" style="width: 269px;height: 269px;" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {
			// hideLoading()
		},
		methods: {
			jumpAbout() {
				console.log('111')
				this.$router.push({
					name: 'about'
				})
			},
		}
	}
</script>

<style lang="less">
	.footer {
		width: 100%;
		height: 128px;
		background-color: #34323D;
		text-align: center;

		.footer-box {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
		}

		.text {
			font-size: 18px;
			font-weight: bold;
			color: #FFFFFF;
		}

		.text:nth-child(2) {
			margin-top: 12px;
		}
	}


	.features {
		width: 100%;
		height: 480px;

		.modle-box {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

			.describe {
				margin-bottom: 30px;
				display: flex;
				flex-direction: column;
				align-items: center;

				.line-1 {
					font-size: 24px;
					font-weight: bold;
					color: #333333;
					margin-bottom: 5px;
				}

				.line-2 {
					width: 115px;
					height: 5px;
					border-radius: 3px;
					background-color: #f03E2E;
					margin-bottom: 10px;
				}
			}

			.item-box {
				display: flex;
				justify-content: space-between;
				width: 100%;

				img {
					width: 88px;
					height: 88px;
				}
			}


		}
	}


	.content {
		width: 1200;
		height: 128px;
		// background-color: #FF0000;
		margin: 0 auto;
	}

	.introduce {
		width: 100%;
		height: 987px;
		background-color: #f6f6f6;

		.modle-box {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

			.describe {
				margin-bottom: 30px;
				display: flex;
				flex-direction: column;
				align-items: center;

				.line-1 {
					font-size: 24px;
					font-weight: bold;
					color: #333333;
					margin-bottom: 5px;
				}

				.line-2 {
					width: 115px;
					height: 5px;
					border-radius: 3px;
					background-color: #f03E2E;
					margin-bottom: 10px;
				}
			}

			.item-box {
				display: flex;
				justify-content: space-between;
				width: 1200px;

				.item {
					width: 571px;
					height: 800px;
					background-color: #f6f6f6;
					box-shadow: 3px 6px 35px 0px rgba(4, 0, 0, 0.11);

					.img-box {
						width: 100%;
						height: 462px;
						background-color: #f6f6f6;
						display: flex;
						justify-content: center;
						align-items: center;

						img {
							width: 241px;
							height: 450px;
						}

					}

					.text-box {
						background-color: #FFFFFF;
						height: 337px;
						display: flex;
						flex-direction: column;
						align-items: center;
					}
				}
			}


		}
	}
</style>
